import { CurrencyCode, SwiftCommission, SwiftUrgency } from '../../../models/payment.interfaces';

function isSwiftData(data: SepaTransferForm | SwiftTransferForm): data is SwiftTransferForm {
  return (data as SwiftTransferForm).swiftCode !== undefined && (data as SwiftTransferForm).beneficiaryBank !== undefined;
}

interface AccountTransferBaseData {
  accountId?: string;
  accountNumber: string;
  currencyCode: CurrencyCode;
  amount: number;
  amountEuro?: number;
}

export class AccountTransferForm implements Required<AccountTransferBaseData> {
  accountId: string;
  accountNumber: string;
  currencyCode: CurrencyCode;
  amount: number;
  amountEuro: number;
  sepaForm: SepaTransferForm;
  swiftForm: SwiftTransferForm;
  constructor(commonData: AccountTransferBaseData, formData: SepaTransferForm | SwiftTransferForm ) {
    Object.assign(this, commonData);
    if (isSwiftData(formData)) {
      this.swiftForm = formData;
    } else {
      this.sepaForm = formData;
    }
  }
}

export class SepaTransferForm {
  beneficiaryName: string;
  transferDetail: string;
  transferComment: string;
  accountType?: string;
  partyNameMatch?: PARTY_NAME_MATCH_TYPE | null;
  requestId?: string
  matchedName?: string
  constructor(data: SepaTransferForm) {
    Object.assign(this, data);
  }
}

export class SwiftTransferForm {
  beneficiaryName: string;
  country: string;
  city: string;
  address: string;
  swiftCode: string;
  beneficiaryBank: string;
  isIntermediaryBank = false;
  intermediarySwift?: string;
  intermediaryAccount?: string;
  commissionType: SwiftCommission;
  urgency: SwiftUrgency;
  transferDetail: string;
  transferComment: string;
  constructor(data: SwiftTransferForm) {
    Object.assign(this, data);
  }
}

export enum PARTY_NAME_MATCH_TYPE {
  MTCH = 'MTCH', // match
  NMTC = 'NMTC', // not match
  CMTC = 'CMTC', // match close
  NOAP = 'NOAP', // Verification check is not possible/applicable for the responding application for any reason
}
export interface BeneficiaryNameCheckResult {
  partyNameMatch: PARTY_NAME_MATCH_TYPE | null;
  requestId: string;
  matchedName: string;
}

